/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  Icon, ICON_CHART_LINE, ICON_INFORMATION_OUTLINE, Popover,
  SlotMachineNumber,
  TypographyName,
} from '@doveit/bricks';
import { formatEuro } from '@doveit/hammer';
import { MetricFrequency } from './types';
import * as styles from './GoalMetricCard.style';
import { configByMetric, frequencyLabels } from './constants';
import { GoalMetric } from '../../../providers/api/dtos/goals';
import { template } from '../../../utils/text/text';

export interface GoalMetricCardProps extends React.AriaAttributes {
  metric: GoalMetric,
  avgCommission: number,
  target: number,
  targetByFrequency: number,
  frequency: MetricFrequency,
}

export const GoalMetricCard: React.FC<GoalMetricCardProps> = ({
  metric,
  target,
  avgCommission,
  targetByFrequency,
  frequency = 'weekly',
  'aria-label': ariaLabel = 'goal-metric-card',
}) => {
  const { icon, label, info } = configByMetric[metric];

  return (
    <div
      css={styles.basic}
      ariaLabel={ariaLabel}
    >
      <div css={styles.header}>
        <div css={styles.title}>
          <div>
            <Icon
              path={icon}
              size={24}
            />
          </div>
          <div css={styles.titleText}>
            <div css={styles.target}>
              <SlotMachineNumber
                value={target}
                typographyName={TypographyName.HEADING_4}
              />
            </div> {label}
          </div>
        </div>
        <div css={styles.popover}>
          <Popover
            trigger={(
              <Icon
                path={ICON_INFORMATION_OUTLINE}
                size={24}
              />
            )}
            hasArrow
          >
            <div css={styles.popoverContent}>
              {template(info, {
                AVG_COMMISSION: formatEuro(avgCommission),
              })}
            </div>
          </Popover>
        </div>
      </div>
      <div css={styles.details}>
        <div>
          <Icon
            path={ICON_CHART_LINE}
            size={16}
          />
        </div>
        <div aria-label="Previsione">
          {targetByFrequency > 0 ? (
            <div>
              <span css={styles.target}>{targetByFrequency}</span> {frequencyLabels[frequency]}
            </div>
          ) : 'Obiettivo raggiunto'}
        </div>
      </div>
    </div>
  );
};

export default GoalMetricCard;
